import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentLang } from "../../lib/slices/langSlice";

const languages = [
  {
    label: "English",
    code: "en",
    flag: "https://flagcdn.com/gb.svg", // UK flag
  },
  {
    label: "Romanian",
    code: "ro",
    flag: "https://flagcdn.com/ro.svg", // Romania flag
  },
];

export default function LanguageMenu() {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const currentLangauge = useSelector(
    (state) => state.languageReducer.currentLanguage
  );

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (lang) => {
    setAnchorEl(null);
    dispatch(setCurrentLang(lang));
  };

  const currentLangData = languages.find((l) => l.code === currentLangauge);

  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title={"Language"}>
          <IconButton
            onClick={handleClick}
            size="small"
            aria-controls={open ? "language-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            sx={{
              borderRadius: 1,
              bgcolor: "#00000014",
              border: "1px solid rgba(0, 0, 0, 0.12)",
              "&:hover": {
                bgcolor: "#00000014",
              },
              px: 0.5,
            }}
          >
            {currentLangData ? (
              <img
                src={currentLangData.flag}
                alt={currentLangData.label}
                style={{ width: 24, height: 16 }}
              />
            ) : (
              <Typography variant="body2">🌐</Typography>
            )}
          </IconButton>
        </Tooltip>
      </Box>

      <Menu
        anchorEl={anchorEl}
        id="language-menu"
        open={open}
        onClose={() => setAnchorEl(null)}
        onClick={() => setAnchorEl(null)}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => handleClose(lang.code)}
            sx={{
              textTransform: "capitalize",
              bgcolor: lang.code === currentLangauge ? "#00000014" : "inherit",
            }}
          >
            <img
              src={lang.flag}
              alt={lang.label}
              style={{ width: 24, height: 16, marginRight: 8 }}
            />
            {lang.label}
          </MenuItem>
        ))}
      </Menu>
    </React.Fragment>
  );
}
